import React from 'react';
import { FieldValues } from 'react-hook-form';
import { ConditionsFieldsByRuleTypeRHF } from '../ConditionsFieldsByRuleType';
import { CriteriaBodyCellProps } from 'modules/jsonRulesCriterias/businessCriteria/types';

export const CriteriaBodyCell = <FormValues extends FieldValues = FieldValues>({
  ruleType,
  control,
  name,
}: CriteriaBodyCellProps<FormValues>) => {
  if (!ruleType) return null;

  return <ConditionsFieldsByRuleTypeRHF name={name} control={control} ruleType={ruleType} />;
};
